<app-dialog-title [title]="data.title" [state]="data.state"></app-dialog-title>
<mat-form-field appearance="outline">
	<mat-label>{{ data.message }}</mat-label>
	<input matInput [(ngModel)]="inputValue" />
	<button
		mat-button
		*ngIf="inputValue"
		matSuffix
		mat-icon-button
		aria-label="Clear"
		(click)="inputValue = ''"
	>
		<mat-icon>close</mat-icon>
	</button>
</mat-form-field>
<div class="row">
	<span class="spacer"></span
	><button
		mat-flat-button
		class="btn-alarm pad-right"
		(click)="dialogRef.close(null)"
	>
		<mat-icon iconPositionEnd>close</mat-icon>
		{{ 'ROOT.STRINGS.CANCEL' | translate }}
	</button>

	<button
		mat-flat-button
		class="btn-okay"
		(click)="dialogRef.close(inputValue)"
		[disabled]="!inputValue"
	>
		<mat-icon iconPositionEnd>check</mat-icon>
		{{ 'ROOT.STRINGS.APPLY' | translate }}
	</button>
</div>
